import { type FC } from 'react';
import { Navigate, Outlet } from 'react-router';

type TProtectedRouteProps = {
  isAllowed?: boolean;
  redirectPath: string;
};

export const ProtectedRoute: FC<TProtectedRouteProps> = ({
  isAllowed,
  redirectPath
}) => {
  if (!isAllowed) {
    return <Navigate to={redirectPath} />;
  }
  return <Outlet />;
};
